import { axios } from '@Root/API'

export const edit = (studyProgrammeId, curriculumAccreditationId, payload) => {
	return axios.post(`program/${studyProgrammeId}/curriculum-accreditation/${curriculumAccreditationId}`, payload)
}
